<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body">
                        <table>
                            <app-item v-for="item in items" :item="item"></app-item>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="modal-default-button" @click="$emit('close')">
                                Releases auswählen
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Header from '../Header';
    import Item from './Alle_release_item';

    export default {
        data() {
            return {
                checked: [2, 3],
            }
        },
        computed: {
            items() {
                return this.$store.getters.Alle_release;
            }
        },
        components: {
            appHeader: Header,
            appItem: Item
        },
        methods: {
            check(id) {
                let index = this.contains(id);
                if (index < 0) {
                    this.checked.push(id);
                } else {
                    this.checked.splice(index, index + 1);
                }
                console.log(this.checked);
            },
            contains(id) {
                let index = this.checked.indexOf(id);
                return index;

            }

        },

    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/variables';

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .7);
        display: block;
        transition: opacity .5s ease;
        margin-top: 60px;
    }

    .modal-wrapper {
        display: block;
        margin-top: 15px;

    }

    .modal-container {
        width: 92%;
        height: 72vh;
        margin: 0px auto;
        padding: 9px 0 !important;
        background-color: $model-container_background;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        overflow: hidden;
        border-radius: 4px;
        position: relative;
    }


    .modal-body {
        margin: 0;
        width: 100%;
        padding: 0;
        border: none;
        overflow: auto;
        max-height: 420px;

        table {
            margin-left: 15px;
            width: 90%;
        }

    }

    .modal-default-button {
        margin: auto;
    }

    .modal-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        button {
            color: $button_full_backGroundColor;
            background-color: $button_full_color;
            border: none;
            font-size: 1.4rem;
            font-weight: 700;
        }

    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }


</style>



// WEBPACK FOOTER //
// src/components/meine_trends/Alle_release.vue